import styles from './AnchorLink.module.scss'

export default function AnchorLink({ title, anchor }) {
  return (
    <a className={styles.link} href={`#${anchor}`}>
      {title}
    </a>
  )
}
